<template>
  <div class="footer-socials__wrapper">
    <a-visibility show :on="[$breakpoint.mobile]">
      <p class="footer-socials__title">Follow Us</p>
    </a-visibility>

    <ul class="footer-socials__container">
      <li
        v-for="social in stayConnected"
        :key="social.Id"
        class="footer-socials__item"
      >
        <a-image
          :image="social.Logo"
          :aspect-ratio="$options.consts.ASPECT_RATIO.SQUARE"
          :url="social.Url"
          :open-in-new-tab="social.OpenInNewTab"
          :directives="social.Directives"
          object-fit="cover"
          class="footer-socials__image"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'FooterSocials',
  consts: {
    ASPECT_RATIO
  },
  computed: {
    ...mapGetters({
      stayConnected: 'stayConnected'
    })
  }
}
</script>

<style lang="scss" scoped>
.footer-socials__wrapper {
  text-align: center;

  .footer-socials__title {
    font-size: 11px;
    line-height: 12px;
    font-weight: 300;
  }

  .footer-socials__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 5px -10px 0;

    .footer-socials__item {
      opacity: 0.4;
      transition: opacity 0.5s ease;
      margin: 15px 10px 0;

      $width: (
        $above-desktop-xl: 30px,
        $mobile: 25px
      );

      @include setStyleByBreakpoint('width', $width);

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
